(() => {
  const TARGET = 'Correo electrónico o número de teléfono';
  const variants = new Set([
    'orreo electrónico o número de teléfono',
    'Orreo electrónico o número de teléfono',
    'correo electrónico o número de teléfono',
    'Correo electrónico o número de teléfono',
    'ccorreo electrónico o número de teléfono',
    'Ccorreo electrónico o número de teléfono'
  ]);

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const fixTrackingCopy = () => {
    const root = document.querySelector('main#MainContent');
    if (!root) return false;

    let changed = false;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;

    while ((node = walker.nextNode())) {
      const original = node.nodeValue || '';
      const normalized = normalize(original);
      if (!variants.has(normalized) || normalized === TARGET) continue;

      const leading = original.match(/^\s*/)?.[0] || '';
      const trailing = original.match(/\s*$/)?.[0] || '';
      node.nodeValue = `${leading}${TARGET}${trailing}`;
      changed = true;
    }

    return changed;
  };

  const init = () => {
    const root = document.querySelector('main#MainContent');
    if (!root) return;

    fixTrackingCopy();

    const observer = new MutationObserver(() => fixTrackingCopy());
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
